import { FC } from 'react'

import styled from 'styled-components'

import { MAX_TABLET_WIDTH } from '../../../Styled/variables'

interface PriceInfoProps {
  price: string
}

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 42px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
  width: fit-content;
  align-items: flex-end;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    align-items: flex-start;
  }
`

const Price = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

const PriceLabel = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

export const PriceInfo: FC<PriceInfoProps> = ({ price }) => (
  <PriceContainer>
    <Price>{price}</Price>
    <PriceLabel>per submission</PriceLabel>
  </PriceContainer>
)
